export const ROUTES_PATHS = {
	HOME: "/",
	LOGIN: "/dang-nhap",
	LUCKYDRAW: "/quay-so",
	QR: "/qr",
};
